import {useContext} from "react";
import {AppContext} from "../context/AppProvider";

function useProvince()
{
    const {country} = useContext(AppContext);

    return [{
        value: 0,
        label: "Chọn tỉnh thành"
    }, ...country.city.map(province => ({
        value: province.id,
        label: province.name
    }))];
}

export default useProvince;